import * as React from 'react';
import styled from 'styled-components';
import * as fonts from 'view/styles/fonts';
import * as grid from 'view/styles/grid';
import { Label } from '@atlaskit/form';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { FieldDescription } from './field-description';

interface FieldBaseProps {
    label: string;
    htmlFor: string;
    errorMessage?: React.ReactNode;
    description?: string | React.ReactNode;
    required?: boolean;
    children?: React.ReactNode;
    noLabel?: boolean;
}

const FieldBase: React.FC<FieldBaseProps> = ({
    label,
    required,
    errorMessage,
    description,
    children,
    noLabel,
    htmlFor,
}) => {
    const renderField = () =>
        noLabel ? (
            children
        ) : (
            <>
                {/* The old label had a margingTop of 20px but Field has marginTop of 8px hence this FieldContainer is required */}
                <FieldContainer>
                    <Label htmlFor={htmlFor}>
                        {label}
                        {required && <RequiredContainer aria-hidden="true">*</RequiredContainer>}
                    </Label>
                </FieldContainer>
                {children}
            </>
        );

    return (
        <div data-test-id={`request-field-${htmlFor}`}>
            {renderField()}
            {!!errorMessage && <ErrorText data-test-id="field-error">{errorMessage}</ErrorText>}
            {description && <FieldDescription>{description}</FieldDescription>}
        </div>
    );
};

export default FieldBase;

const ErrorText = styled.p`
    ${fonts.small};
    margin-top: ${token('space.050', '4px')};
    color: ${token('color.text.danger', colors.R500)};
`;

const FieldContainer = styled.div`
    margin-top: ${grid.multiple(2.25).px};
`;

const RequiredContainer = styled.span`
    padding-left: ${token('space.025', '2px')};
    color: ${token('color.text.danger', colors.R400)};
`;
